
import {Component, Vue, Prop, Watch} from "vue-property-decorator";
import i18n from "../../plugins/vue-i18n";
import ActivityFilterComptage from "@/components/comptage/filters/ActivityFilterComptage.vue";
import AdvancedFilterComptage from "@/components/comptage/filters/AdvancedFilterComptage.vue";
import GeolocationFilterComptage from "@/components/comptage/filters/GeolocationFilterComptage.vue";
import KeyNumbersFilterComptage from "@/components/comptage/filters/KeyNumbersFilterComptage.vue";
import LegalFilterComptage from "@/components/comptage/filters/LegalFilterComptage.vue";
import SolvabilityFilterComptage from "@/components/comptage/filters/SolvabilityFilterComptage.vue";
import IFiltersComptage from "@/types/filters-comptage.interface";
import IComptage from "@/types/comptage.interface";

@Component({
    components: {
        ActivityFilterComptage, AdvancedFilterComptage, GeolocationFilterComptage,
        KeyNumbersFilterComptage, LegalFilterComptage, SolvabilityFilterComptage
    },
})
export default class FiltersComptage extends Vue {
    tabInit = '0';
    items = [
        {index: '0', tab: i18n.tc("comptage.filters.activity"), content: "ActivityFilterComptage"},
        {index: '1', tab: i18n.tc("comptage.filters.legal"), content: "LegalFilterComptage"},
        {index: '2', tab: i18n.tc("comptage.filters.geolocation"), content: "GeolocationFilterComptage"},
        {index: '3', tab: i18n.tc("comptage.filters.solvability"), content: "SolvabilityFilterComptage"},
        {index: '4', tab: i18n.tc("comptage.filters.keyNumber"), content: "KeyNumbersFilterComptage"},
        {index: '5', tab: i18n.tc("comptage.filters.advanced"), content: "AdvancedFilterComptage"},
    ];

    @Prop() readonly setFilters!: {};
    @Prop() readonly product: IComptage;
    @Prop() readonly stepper: string;
    @Prop() readonly loading: boolean;

    @Watch('stepper', {deep: true})
    trigger() {
        if (this.stepper === '2') {
            this.tabInit = '0';
        }
    }

    setScore(key: string, value: boolean) {
        this.$emit('set-score', key, value);
    }

    setKeyNumbers(key: string, valueType: string, value1: string, value2: string) {
        this.$emit('set-keynumbers', key, valueType, value1, value2);
    }

    setAdvanced(key: string, value: boolean) {
        this.$emit('set-advanced', key, value);
    }

}
